import { Routes } from "@angular/router";
import { PageNotFoundComponent } from "projects/common/src/lib/page-not-found/page-not-found.component";
import { LoginPageComponent } from "./pages/login-page/login-page.component";
import { HomePageComponent } from "./pages/home-page/home-page.component";
import { AuthenticatedGuard } from "./pages/authenticated-guard";
import { UnauthenticatedGuard } from "./pages/unauthenticated-guard";

export const routes: Routes = [
    { path: HomePageComponent.Path, component: HomePageComponent, canActivate: [AuthenticatedGuard] },
    { path: LoginPageComponent.Path, component: LoginPageComponent, canActivate: [UnauthenticatedGuard] },
    { path: "**", component: PageNotFoundComponent },
];
